import client from '../client';

export interface Setting {
  key: string;
  value: string;
}

export const settingsApi = {
  getSettings: () => client.get<{ data: Setting[] }>('/settings').then((d: any) => d.data.data),
  updateSetting: (key: string, value: string) =>
    client.patch<{ data: Setting }>(`/settings/${key}`, { value }).then((d: any) => d.data.data),
};
